import { useId, useState } from 'react';
import { DialogLayer } from '../ui/Dialog';

/**
 * Owner 2026-10-28 12:01 („Potwierdź ręcznie”): the small step before a confirmation by hand — from the grid's cell menu
 * (one cell or every chosen cell) and from the event panel's row „⋯”. `subject` says what is confirmed („Jan Kowalski ·
 * Wesele A · 9.11.2030”, „Zaznaczone: 3 komórki”); the optional note is kept with the confirmation (the ⓘ shows it).
 */
export function ConfirmManualDialog({ subject, busy, error, onConfirm, onClose }: { subject: string; busy: boolean; error?: string | null; onConfirm: (note: string) => void; onClose: () => void }) {
  const [note, setNote] = useState('');
  const title = useId();
  const field = useId();
  return (
    <div className="dialog-backdrop">
      <form
        className="dialog panel"
        role="dialog"
        aria-modal="true"
        aria-labelledby={title}
        data-feature-id="crew.grid_staffing"
        onSubmit={(e) => {
          e.preventDefault();
          if (!busy) onConfirm(note.trim());
        }}
      >
        <DialogLayer onClose={onClose} busy={busy} />
        <h2 id={title}>Potwierdź ręcznie</h2>
        <p>{subject}</p>
        <p className="muted">Status zmieni się na „Potwierdzony”. Nikt nie dostanie wiadomości.</p>
        <div className="field">
          <label htmlFor={field}>Uwagi (opcjonalnie)</label>
          <textarea id={field} rows={2} maxLength={2000} placeholder="Uwagi, np. potwierdził telefonicznie" value={note} autoFocus onChange={(e) => setNote(e.target.value)} />
        </div>
        {error && (
          <p className="alert" role="alert">
            {error}
          </p>
        )}
        <div className="actions">
          <button className="btn primary" type="submit" disabled={busy}>
            {busy ? 'Zapisywanie…' : 'Potwierdź'}
          </button>
          <button className="btn" type="button" disabled={busy} onClick={onClose}>
            Anuluj
          </button>
        </div>
      </form>
    </div>
  );
}
